import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setStatus({ commit }, status) {
    commit(types.SET_STATUS, status)
  },
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setRetrospectiveDay({ commit }, days) {
    commit(types.SET_DAYS, days)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setFilterOptions({ commit }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  setContactChecked({ commit }, data) {
    commit(types.SET_CONTACT_CHECKED, data)
  },
  addContact({ commit }, contact) {
    commit(types.ADD_CONTACT, contact)
  },
  updateContact({ commit }, data) {
    commit(types.UPDATE_CONTACT, data)
  },
  setItem({ commit }, item) {
    commit(types.SET_ITEM, item)
  },
  addAddress({ commit }, address) {
    commit(types.ADD_ADDRESS, address)
  },
  removeAddress({ commit }, id) {
    commit(types.REMOVE_ADDRESS, id)
  },
  addPhone({ commit }, phone) {
    commit(types.ADD_PHONE, phone)
  },
  removePhone({ commit }, id) {
    commit(types.REMOVE_PHONE, id)
  },
  addEmail({ commit }, email) {
    commit(types.ADD_EMAIL, email)
  },
  removeEmail({ commit }, id) {
    commit(types.REMOVE_EMAIL, id)
  },
  initContacts({ commit }) {
    commit(types.SET_CONTACTS_FOUND, null)
  },
  async lookupContact({ commit, dispatch }, search) {
    const r = await startLoading(dispatch, 'lookupContact', () => http.get(`contact/lookupContact?search=${search}`))
    return r.data
  },
  async getContact({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getContact', () => http.get(`contact/contact?id=${id}`))
    commit(types.SET_CONTACT, r.data)
    return r.data
  },
  async getFirmContact({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getFirmContact', () => http.get(`firm/editFirm?id=${id}`))
    commit(types.SET_CONTACT, r.data)
    return r.data
  },
  async getContacts({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getContacts', () =>
      http.get('contact/contacts', {
        params: searchOptions
      })
    )
    commit(types.SET_CONTACTS, { data: r.data, isVendors: false })
    return r.data
  },
  async saveContact({ commit, state, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveContact', () => http.post('contact/saveContact', state.contact))
    return r.data
  },
  async mergeContacts({ commit, state, dispatch }, ids) {
    const r = await startLoading(dispatch, 'mergeContacts', () => http.get(`contact/mergeContacts?ids=${ids}`))
    return r.data
  },
  async searchContacts({ commit, dispatch }, search) {
    let _contacts = []
    if (search !== undefined && search !== null) {
      if (search.searchterm !== '') {
        let url = ''
        url = `contact/contactSearch/?firmid=${search.firmid}&searchterm=${search.searchterm}`
        if (search.type !== undefined && search.type !== null) {
          if (search.type !== '') {
            url += '&type=' + search.type
          }
        }
        let data = await http.get(url)
        if (data !== undefined && data !== null) {
          if (data.data !== undefined && data.data !== null) {
            for (let item of data.data) {
              let name = item.fullName
              if (search.forUsers !== undefined && search.forUsers !== null) {
                if (item.emailAddress !== null) {
                  name += ' - ' + item.emailAddress
                }
              } else {
                if (item.phoneNo !== undefined && item.phoneNo !== null) {
                  if (item.phoneNo !== null) {
                    name += ' - ' + item.phoneNo
                  }
                }
              }
              let contact = {
                id: item.contact,
                name: name,
                contact: item.contact,
                fileAs: item.fileAs,
                firstName: item.firstName,
                lastName: item.lastName,
                phoneNo: item.phoneNo,
                email: item.emailAddress,
                userId: item.user,
                guid: item.guid
              }
              _contacts.push(contact)
            }
          }
        }
        commit(types.SET_CONTACTS_FOUND, _contacts)
      }
    }
    return _contacts
  },
  async searchAddresses({ commit, dispatch }, search) {
    let _addresses = []
    if (search !== undefined && search !== null) {
      if (search.searchterm !== '') {
        let url = ''
        if (search.department !== undefined && search.department !== null) {
          url = `contact/addressSearch/?firmid=${search.firmid}&searchterm=${search.searchterm}&department=${search.department}`
        } else {
          url = `contact/addressSearch/?firmid=${search.firmid}&searchterm=${search.searchterm}`
        }
        if (search.type !== undefined && search.type !== null) {
          if (search.type !== '') {
            url += '&type=' + search.type
          }
        }
        let data = await http.get(url)
        if (data !== undefined && data !== null) {
          for (let item of data.data.items) {
            let name = item.fullName
            if (item.addressLines !== undefined && item.addressLines !== null) {
              if (item.addressLines.length > 40) {
                name += ' - ' + item.addressLines.substring(0, 37) + '...'
              } else {
                name += ' - ' + item.addressLines
              }
            }
            let address = {
              id: item.address,
              name: name,
              contact: item.contact,
              fileAs: item.fileAs,
              firstName: item.firstName,
              lastName: item.lastName,
              phoneNo: item.phoneNo,
              address: item.addressLines
            }
            _addresses.push(address)
          }
        }
        commit(types.SET_ADDRESSES_FOUND, _addresses)
      }
    }
    return _addresses
  },
  async searchPhones({ commit, dispatch }, search) {
    let _phones = []
    if (search !== undefined && search !== null) {
      if (search.searchterm !== '') {
        let url = ''
        if (search.department !== undefined && search.department !== null) {
          url = `contact/phoneSearch/?firmid=${search.firmid}&searchterm=${search.searchterm}&department=${search.department}`
        } else {
          url = `contact/phoneSearch/?firmid=${search.firmid}&searchterm=${search.searchterm}`
        }
        if (search.type !== undefined && search.type !== null) {
          if (search.type !== '') {
            url += '&type=' + search.type
          }
        }
        let data = await http.get(url)
        if (data !== undefined && data !== null) {
          for (let item of data.data.items) {
            let name = item.fullName
            if (item.phoneNo !== undefined && item.phoneNo !== null) {
              name += ' - ' + item.phoneNo
            }
            let phone = {
              id: item.phone,
              name: name,
              contact: item.contact,
              fileAs: item.fileAs,
              firstName: item.firstName,
              lastName: item.lastName,
              phoneNo: item.phoneNo
            }
            _phones.push(phone)
          }
        }
        commit(types.SET_PHONES_FOUND, _phones)
      }
    }
    return _phones
  },
  async getContactAddress({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getContactAddress', () => http.get(`contact/contactAddress?id=${id}`))
    commit(types.SET_CONTACT_ADDRESS, r.data)
    return r.data
  },
  async getContactAddresses({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getContactAddresses', () => http.get(`contact/contactAddresses?id=${id}`))
    commit(types.SET_CONTACT_ADDRESSES, r.data)
    return r.data
  },
  async getContactPhones({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getContactPhones', () => http.get(`contact/contactPhones?id=${id}`))
    commit(types.SET_CONTACT_PHONES, r.data)
    return r.data
  },
  async getContactEmails({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getContactEmails', () => http.get(`contact/contactEmails?id=${id}`))
    commit(types.SET_CONTACT_EMAILS, r.data)
    return r.data
  },
  setCheckedAddress({ commit }, data) {
    commit(types.SET_CHECKED_ADDRESS, data)
  },
  async saveAddress({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveAddress', () => http.post('contact/saveAddress', data))
    commit(types.SAVE_ADDRESS, { address: data, result: r.data })
  },
  async deleteAddress({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'deleteAddress', () => http.post('contact/deleteAddress', data))
    commit(types.DELETE_ADDRESS, { data: data, result: r.data })
  },
  async setPrimaryAddress({ commit, dispatch }, data) {
    await startLoading(dispatch, 'setPrimaryAddress', () => http.get(`contact/setPrimaryAddress?id=${data.id}&contact=${data.contact}`))
    commit(types.SET_PRIMARY_ADDRESS, data.id)
  },
  setCheckedPhone({ commit }, data) {
    commit(types.SET_CHECKED_PHONE, data)
  },
  async savePhone({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'savePhone', () => http.post('contact/savePhone', data))
    commit(types.SAVE_PHONE, { phone: data, result: r.data })
  },
  async deletePhone({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'deletePhone', () => http.post('contact/deletePhone', data))
    commit(types.DELETE_PHONE, { data: data, result: r.data })
  },
  async setPrimaryPhone({ commit, dispatch }, data) {
    await startLoading(dispatch, 'setPrimaryPhone', () => http.get(`contact/setPrimaryPhone?id=${data.id}&contact=${data.contact}`))
    commit(types.SET_PRIMARY_PHONE, data)
  },
  setCheckedEmail({ commit }, data) {
    commit(types.SET_CHECKED_EMAIL, data)
  },
  async saveEmail({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveEmail', () => http.post('contact/saveEmail', data))
    commit(types.SAVE_EMAIL, { email: data, result: r.data })
  },
  async deleteEmail({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'deleteEmail', () => http.post('contact/deleteEmail', data))
    commit(types.DELETE_EMAIL, { data: data, result: r.data })
  },
  async setPrimaryEmail({ commit, dispatch }, data) {
    await startLoading(dispatch, 'setPrimaryEmail', () => http.get(`contact/setPrimaryEmail?id=${data.id}&contact=${data.contact}`))
    commit(types.SET_PRIMARY_EMAIL, data)
  },
  async getRelated({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getRelated', () => http.get(`contact/related?id=${id}`))
    commit(types.SET_RELATED, r.data)
    return r.data
  },
  async saveRelated({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveRelated', () => http.post('contact/saveRelated', data))
    return r.data
  },
  async deleteRelated({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'deleteRelated', () => http.post(`contact/deleteRelated?id=${id}`))
    return r.data
  },
  async getVendor({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getContact', () => http.get(`contact/vendor?id=${id}`))
    commit(types.SET_CONTACT, r.data)
    return r.data
  },
  async getVendors({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getContacts', () =>
      http.get('contact/vendors', {
        params: searchOptions
      })
    )
    commit(types.SET_CONTACTS, { data: r.data, isVendors: true })
    return r.data
  },
  async saveVendor({ commit, state, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveContact', () => http.post('contact/saveVendor', data))
    return r.data
  },
  async searchVendors({ commit, dispatch }, search) {
    let _contacts = []
    if (search !== undefined && search !== null) {
      if (search.searchterm !== '') {
        let url = ''
        if (search.department !== undefined && search.department !== null) {
          url = `contact/vendorSearch/?firmid=${search.firmid}&searchterm=${search.searchterm}&department=${search.department}`
        } else {
          url = `contact/vendorSearch/?firmid=${search.firmid}&searchterm=${search.searchterm}`
        }
        if (search.type !== undefined && search.type !== null) {
          if (search.type !== '') {
            url += '&type=' + search.type
          }
        }
        let data = await http.get(url)
        if (data !== undefined && data !== null) {
          if (data.data.items !== undefined && data.data.items !== null) {
            for (let item of data.data.items) {
              let name = item.companyName
              if (item.phoneNo !== undefined && item.phoneNo !== null) {
                name += ' - ' + item.phoneNo
              }
              let contact = {
                id: item.contact,
                name: name,
                contact: item.contact,
                fileAs: item.companyName,
                firstName: item.firstName,
                lastName: item.lastName,
                phoneNo: item.phoneNo
              }
              _contacts.push(contact)
            }
          }
        }
        commit(types.SET_CONTACTS_FOUND, _contacts)
      }
    }
    return _contacts
  },
  async setInactive({ commit, state, dispatch }, ids) {
    const r = await startLoading(dispatch, 'setInactive', () => http.get(`contact/setInactive?ids=${ids}`))
    return r.data
  },
  async fetchValidatedAddresses({ commit, state, dispatch }, data) {
    let address = `${data.address.addressLines}`
    if (address.includes(',')) {
      address = address.split(',')[0].trim()
    }
    address += ` ${data.address.city} ${data.address.stateProvince} ${data.address.postalCode} ${data.address.country}`
    address = address.replace(/#/g, '')
    const url = `https://atlas.microsoft.com/search/address/json?api-version=1.0&query=${address}&subscription-key=${data.key}`
    const response = await fetch(url)
    data = await response.json()
    if (data.summary.numResults > 0) {
      commit(types.SET_ADDRESSES_FOUND, data.results)
      commit(types.SET_VALIDATED_ADDRESS, data.results[0])
      return data.results
    }
  },
  clearAddressesFound({ commit }) {
    commit(types.CLEAR_ADDRESSES_FOUND, [])
    commit(types.CLEAR_VALIDATED_ADDRESS, null)
  },
  async getChildAddresses({ commit, dispatch }, firm) {
    const r = await startLoading(dispatch, 'getChildAddresses', () => http.get(`firm/getChildFirms?firm=${firm}&gettype=addressValidation`))
    commit(types.SET_CHILD_ADDRESSES, r.data)
    return r.data
  },
  clearContactAddresses({ commit }) {
    commit(types.CLEAR_CONTACT_ADDRESSES, [])
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/contacts/actions.js